import script from "./UsersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersPage.vue?vue&type=script&setup=true&lang=ts"

import "./UsersPage.vue?vue&type=style&index=0&id=aaa8494e&lang=scss"

const __exports__ = script;

export default __exports__